module.exports = __webpack_public_path__ + "media/images/image-placeholder-6fff15af2c0d2d69dfa9c68f4cfd9046.jpg";